import type { FC } from 'react';

import { Icon } from '@iconify/react';
import { useContext } from 'react';
import { tss } from 'tss-react/mui';

import { BreadcrumbContext } from '../../../context';
import { NavMenuItem } from '../../NavMenuItem';

const useStyles = tss.create(({ theme }) => ({
  root: {
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
    },
    'backgroundColor': theme.palette.action.hover,
  },
  text: {
    fontWeight: 'bold',
  },
}));

export const BackNavItem: FC = () => {
  const { classes } = useStyles();

  const { breadcrumbs } = useContext(BreadcrumbContext);
  if (!breadcrumbs?.length || breadcrumbs.length < 2) {
    return null;
  }
  const upperLevel = breadcrumbs[breadcrumbs.length - 2];
  if (!upperLevel) {
    return null;
  }
  return (
    <NavMenuItem
      classes={{ root: classes.root, text: classes.text }}
      isSubmenu
      item={{
        icon: <Icon icon="material-symbols:arrow-back" />,
        target: upperLevel.link ?? '',
        title: upperLevel.title,
      }}
    />
  );
};
